import createCustomContext from '../../contexts/create-custom-context.js';

const [LegacyAutocompleteContextProvider, useLegacyAutocompleteContext] = createCustomContext('LegacyAutocompleteContext', {
  containerId: '',
  focusableOptions: [],
  focusedOption: -1,
  isMultiselect: false
});

export { LegacyAutocompleteContextProvider, useLegacyAutocompleteContext };
